import { UserProfile } from 'oidc-client-ts';

import CredentialStorage from './CredentialStorage';

import { env } from 'utils/env';

export const KEY_CREDENTIAL = `oidc.user:${env.CLASSTING_OIDC_URL}/oidc:${env.CLASSTING_OIDC_CLIENT_ID}`;

type CredentialParamObject = {
  token_type: string;
  access_token: string;
};

type CredentialUser = CredentialParamObject & {
  id_token?: string;
  session_state?: string | null;
  refresh_token?: string;
  scope?: string;
  profile: UserProfile | null;
  expires_at?: number;
  userState?: unknown;
};

type Credential = {
  type: string;
  accessToken: string;
};

export const storage = new CredentialStorage();

export const setCredential = (
  credentialParamObject: CredentialParamObject
): void => {
  storage.setItem(KEY_CREDENTIAL, JSON.stringify(credentialParamObject));
};

export const getCredential = (): Credential | null => {
  const credentialInfo = storage.getItem(KEY_CREDENTIAL);

  if (credentialInfo) {
    const credential = JSON.parse(credentialInfo) as CredentialUser;

    if (credential?.token_type && credential?.access_token) {
      return {
        type: credential.token_type,
        accessToken: credential.access_token,
      };
    }
  }

  return null;
};

export const clearCredential = (): void => {
  storage.clear();
};
